<div class="kb-page">

  <!-- ══ ENCABEZADO ═══════════════════════════════════════════════════════ -->
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title">Nueva venta financiada</h1>
      <p class="kb-page-desc">
        Simule el crédito con el cupo real del cliente y créelo sin cambiar de pantalla, como lo haría una caja del modelo viejo: por la pasarela.
        La pantalla que se usa hoy sigue disponible en <span class="font-medium">Crear crédito</span>.
      </p>
    </div>
    <div class="flex items-center gap-3">
      <div class="kb-acciones-grupo">
      <!-- Atajo: cobrar la inicial de un crédito que ya existe, sin volver a
           pasar por la simulación ni por la creación. -->
      <button type="button" class="kb-btn kb-btn-outline" (click)="abrirInicialSuelta()">
        <i class="fas fa-hand-holding-usd"></i> Cargar inicial de un crédito
      </button>
      <span class="kb-badge kb-badge-contorno">versión de prueba</span>
    </div>
      <!-- La explicación de la pantalla no compite con el formulario: vive acá. -->
      <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="ayudaAbierta = true"
              title="Cómo funciona esta pantalla" aria-label="Cómo funciona esta pantalla">
        <i class="fas fa-question-circle"></i>
      </button>
    </div>
  </div>


  <!-- ══ SOLO GERENCIA ════════════════════════════════════════════════════
       Crear un credito es plata que sale. La pantalla completa —incluida la
       simulacion, que ya expone el cupo del cliente— es solo para Gerencia. -->
  <div class="kb-empty" *ngIf="!esGerente">
    <div class="kb-empty-icono"><i class="fas fa-lock"></i></div>
    <div class="kb-empty-titulo">Solo para Gerencia</div>
    <div class="kb-empty-texto">
      Crear un credito lo hace unicamente el personal de Gerencia. Si necesitas cargar una venta,
      pedila por el canal de siempre.
    </div>
  </div>

  <ng-container *ngIf="esGerente">

  <!-- Plantilla: a qué URL se llamó, con qué código HTTP y qué trace_id (sin secretos). -->
  <ng-template #trazaTpl let-claves="claves">
    <ng-container *ngFor="let l of llamadasLista">
      <div class="kb-hint" *ngIf="claves.includes(l.clave)">
        <span class="font-medium">{{ l.paso }}</span> → {{ l.url }} ·
        HTTP {{ l.status || 'sin respuesta' }}
        <span *ngIf="l.traceId"> · trace_id {{ l.traceId }}</span>
        · {{ l.hora | date:'HH:mm:ss' }}
      </div>
    </ng-container>
  </ng-template>

  <!-- ══ CREDENCIALES DE LA CAJA ═══════════════════════════════════════════
       Con esto la pantalla habla con la PASARELA como una caja real. Se guardan
       en este navegador (localStorage). La llave y la clave no se muestran. -->
  <div class="kb-card mx-auto mb-6 w-full max-w-4xl">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title">Credenciales de la caja</h2>
        <p class="kb-card-desc">
          Los pasos de la caja salen por la pasarela con estas credenciales.
          <span class="kb-badge" [ngClass]="estadoToken.clase">{{ estadoToken.texto }}</span>
          <span *ngIf="estadoToken.hasta"> {{ estadoToken.texto === 'token vigente' ? 'hasta' : 'venció a las' }}
            {{ estadoToken.hasta | date:'dd/MM HH:mm:ss' }} ({{ estadoToken.mascara }})</span>
        </p>
      </div>
      <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="credAbierta = !credAbierta">
        <i class="fas" [ngClass]="credAbierta ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        {{ credAbierta ? 'Ocultar' : 'Mostrar' }}
      </button>
    </div>

    <div class="kb-card-body" *ngIf="credAbierta">
      <div class="space-y-4">
        <div>
          <label class="kb-label" for="cred-url">URL de la pasarela</label>
          <input id="cred-url" class="kb-input" type="text" [(ngModel)]="cred.url" [ngModelOptions]="{standalone: true}"
                 placeholder="https://qa-api-integrations-gateways.creditotal.online" autocomplete="off" />
          <p class="kb-hint">Sin /api/v1 al final: la pantalla lo agrega.</p>
        </div>

        <div>
          <label class="kb-label" for="cred-key">x-api-key</label>
          <div class="flex items-center gap-2">
            <input id="cred-key" class="kb-input" [type]="verApiKey ? 'text' : 'password'" [(ngModel)]="cred.apiKey"
                   [ngModelOptions]="{standalone: true}" autocomplete="off" placeholder="Llave del departamento" />
            <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="verApiKey = !verApiKey"
                    [title]="verApiKey ? 'Ocultar' : 'Ver'" [attr.aria-label]="verApiKey ? 'Ocultar la llave' : 'Ver la llave'">
              <i class="fas" [ngClass]="verApiKey ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label class="kb-label" for="cred-id">Identificador (login de proveedor)</label>
            <input id="cred-id" class="kb-input" type="text" [(ngModel)]="cred.identificador"
                   [ngModelOptions]="{standalone: true}" autocomplete="off" />
          </div>
          <div>
            <label class="kb-label" for="cred-clave">Clave</label>
            <div class="flex items-center gap-2">
              <input id="cred-clave" class="kb-input" [type]="verClave ? 'text' : 'password'" [(ngModel)]="cred.clave"
                     [ngModelOptions]="{standalone: true}" autocomplete="new-password" />
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="verClave = !verClave"
                      [title]="verClave ? 'Ocultar' : 'Ver'" [attr.aria-label]="verClave ? 'Ocultar la clave' : 'Ver la clave'">
                <i class="fas" [ngClass]="verClave ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
          </div>
        </div>

        <p class="kb-hint">
          Según el modo del departamento la pasarela pide la llave, el token o las dos
          (los integradores externos usan las dos). Se mandan las que estén cargadas.
          Si el token vence o la pasarela responde 401, se vuelve a iniciar sesión una vez sola.
        </p>

        <div class="kb-aviso kb-aviso-peligro" *ngIf="mensajeCred?.tipo === 'error'">
          <div>{{ mensajeCred?.texto }}</div>
        </div>
        <div class="kb-aviso kb-aviso-info" *ngIf="mensajeCred?.tipo === 'ok'">
          <div>{{ mensajeCred?.texto }}</div>
        </div>

        <div class="kb-acciones-grupo">
          <button type="button" class="kb-btn kb-btn-primary" (click)="guardarCred()">
            <i class="fas fa-save"></i> Guardar
          </button>
          <button type="button" class="kb-btn kb-btn-outline" (click)="obtenerToken()" [disabled]="obteniendoToken">
            <i class="fas fa-key" *ngIf="!obteniendoToken"></i>
            <i class="fas fa-circle-notch fa-spin" *ngIf="obteniendoToken"></i>
            {{ obteniendoToken ? 'Pidiendo…' : 'Obtener token' }}
          </button>
          <button type="button" class="kb-btn kb-btn-ghost" (click)="borrarCred()">
            <i class="fas fa-trash"></i> Borrar todo
          </button>
        </div>

        <ng-container *ngTemplateOutlet="trazaTpl; context: {claves: ['login']}"></ng-container>
      </div>
    </div>
  </div>

  <!-- ══ LOS TRES PASOS ═══════════════════════════════════════════════════ -->
  <div class="kb-steps">
    <div class="kb-step">
      <span class="kb-step-bolita" [ngClass]="{'kb-step-bolita-hecha': puntoDeVentaListo, 'kb-step-bolita-activa': !puntoDeVentaListo}">1</span>
      <span class="kb-step-label" [ngClass]="{'kb-step-label-activa': !puntoDeVentaListo}">Punto de venta</span>
      <span class="kb-step-linea"></span>
    </div>
    <div class="kb-step">
      <span class="kb-step-bolita" [ngClass]="{'kb-step-bolita-hecha': simulacion, 'kb-step-bolita-activa': puntoDeVentaListo && !simulacion}">2</span>
      <span class="kb-step-label" [ngClass]="{'kb-step-label-activa': puntoDeVentaListo && !simulacion}">Simulación</span>
      <span class="kb-step-linea"></span>
    </div>
    <div class="kb-step">
      <span class="kb-step-bolita" [ngClass]="{'kb-step-bolita-activa': simulacion && !resultado?.exito, 'kb-step-bolita-hecha': resultado?.exito}">3</span>
      <span class="kb-step-label" [ngClass]="{'kb-step-label-activa': simulacion && !resultado?.exito}">Crear el crédito</span>
      <span class="kb-step-linea"></span>
    </div>
    <div class="kb-step">
      <span class="kb-step-bolita" [ngClass]="{'kb-step-bolita-activa': resultado?.exito && cierre !== 'listo', 'kb-step-bolita-hecha': cierre === 'listo'}">4</span>
      <span class="kb-step-label" [ngClass]="{'kb-step-label-activa': resultado?.exito}">Pagaré e inicial</span>
    </div>
  </div>

  <div class="mx-auto w-full max-w-4xl">

    <div class="space-y-6">

      <!-- ── Punto de venta: se confirma una vez y no se toca más ───────── -->
      <div class="kb-card">
        <div class="kb-card-header">
          <div>
            <h2 class="kb-card-title">Punto de venta</h2>
            <p class="kb-card-desc">La tienda define a qué comercio se le liquida esta venta.</p>
          </div>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                  *ngIf="!editandoPuntoVenta"
                  (click)="editandoPuntoVenta = true">
            <i class="fas fa-pen"></i> Cambiar
          </button>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
                  *ngIf="editandoPuntoVenta"
                  (click)="editandoPuntoVenta = false">
            <i class="fas fa-check"></i> Listo
          </button>
        </div>

        <div class="kb-card-body">

          <div *ngIf="cargandoTiendas" class="space-y-3">
            <div class="kb-skeleton h-4 w-40"></div>
            <div class="kb-skeleton h-4 w-64"></div>
          </div>

          <!-- Lectura -->
          <div class="kb-kv" *ngIf="!cargandoTiendas && !editandoPuntoVenta">
            <div>
              <div class="kb-kv-label">Comercio</div>
              <div class="kb-kv-valor" *ngIf="comercioDeLaVenta">
                {{ comercioDeLaVenta }}
                <span class="kb-badge kb-badge-marca">se le liquida a este</span>
              </div>
              <div class="kb-kv-vacio" *ngIf="!comercioDeLaVenta">sin comercio: elegí la tienda</div>
            </div>
            <div>
              <div class="kb-kv-label">Tienda</div>
              <div class="kb-kv-valor" *ngIf="tiendaActual">
                {{ tiendaActual?.name || tiendaActual?.code }}
              </div>
              <div class="kb-kv-vacio" *ngIf="!tiendaActual">sin elegir</div>
            </div>
            <div>
              <div class="kb-kv-label">Código</div>
              <div class="kb-kv-valor" *ngIf="tiendaSeleccionada">{{ tiendaSeleccionada }}</div>
              <div class="kb-kv-vacio" *ngIf="!tiendaSeleccionada">sin elegir</div>
            </div>
            <div>
              <div class="kb-kv-label">Ejecutivo</div>
              <div class="kb-kv-valor" *ngIf="idEjecutive">
                {{ idEjecutive }}
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="cambiarEjecutivo()">Cambiar</button>
              </div>
              <div class="kb-kv-vacio" *ngIf="!idEjecutive">sin registrar</div>
            </div>
            <div>
              <div class="kb-kv-label">Tasa del día</div>
              <div class="kb-kv-valor" *ngIf="!rate_load && !rate_error">{{ rate?.amount }} Bs / USD</div>
              <div class="kb-kv-vacio" *ngIf="rate_load">buscando…</div>
              <div class="kb-kv-vacio" *ngIf="rate_error">no se pudo consultar</div>
            </div>
          </div>

          <!-- Edición -->
          <div class="grid grid-cols-1 gap-4 sm:grid-cols-2" *ngIf="!cargandoTiendas && editandoPuntoVenta">
            <div>
              <label class="kb-label" for="tienda">Tienda</label>
              <div class="kb-select-envoltorio">
                <select id="tienda" class="kb-select" [(ngModel)]="tiendaSeleccionada" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="null">Elegí una tienda…</option>
                  <option *ngFor="let t of tiendas" [ngValue]="t.code">{{ t?.name || t?.code }} ({{ t?.code }})</option>
                </select>
                <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
              </div>
              <p class="kb-hint" *ngIf="!comercioDeLaVenta">
                Sin tienda no se puede simular: la venta no se podría atribuir a ningún comercio.
              </p>
              <p class="kb-hint" *ngIf="comercioDeLaVenta">
                Esta venta se le liquida a <span class="font-medium text-foreground">{{ comercioDeLaVenta }}</span>.
              </p>
            </div>
          </div>

          <!-- Ejecutivo: texto libre, igual que en la pantalla vieja -->
          <div class="mt-4" *ngIf="!idEjecutive || editandoEjecutivo">
            <div class="kb-separador mb-4"></div>
            <form [formGroup]="formEjecutive" (ngSubmit)="setIdEjecutive()">
              <label class="kb-label">Cédula del ejecutivo que atiende</label>
              <div class="flex flex-wrap items-start gap-3">
                <div class="kb-select-envoltorio w-24">
                  <select class="kb-select" formControlName="code_identity">
                    <option *ngFor="let c of code_identity" [value]="c?.code || c">{{ c?.name || c?.code || c }}</option>
                  </select>
                  <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
                </div>
                <input class="kb-input w-44" type="text" formControlName="identity" placeholder="12345678" />
                <button type="submit" class="kb-btn kb-btn-primary" [disabled]="formEjecutive.invalid">Guardar</button>
              </div>
              <p class="kb-hint">Queda guardado en este navegador. No sale del usuario de la sesión.</p>
            </form>
          </div>

        </div>
      </div>

      <!-- ── Datos de la venta ──────────────────────────────────────────── -->
      <div class="kb-card" *ngIf="!simulacion">
        <div class="kb-card-header">
          <div>
            <h2 class="kb-card-title">Datos de la venta</h2>
            <p class="kb-card-desc">Simular no escribe nada: solo consulta el cupo y arma el plan de pago.</p>
          </div>
        </div>

        <div class="kb-card-body">
          <form [formGroup]="form" (ngSubmit)="simular()" class="space-y-5">

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
              <div>
                <label class="kb-label" for="code_identity">Documento</label>
                <div class="kb-select-envoltorio">
                  <select id="code_identity" class="kb-select" formControlName="code_identity">
                    <option *ngFor="let c of code_identity" [value]="c?.code || c">{{ c?.name || c?.code || c }}</option>
                  </select>
                  <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
                </div>
              </div>
              <div class="sm:col-span-2">
                <label class="kb-label" for="identity">Número</label>
                <input id="identity" class="kb-input" type="text" formControlName="identity"
                       placeholder="12345678" maxlength="8"
                       [ngClass]="{'kb-input-invalido': form.get('identity')?.touched && form.get('identity')?.invalid}" />
                <p class="kb-error" *ngIf="form.get('identity')?.touched && form.get('identity')?.invalid">
                  Entre 6 y 8 dígitos.
                </p>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
              <div>
                <label class="kb-label" for="currency">Moneda</label>
                <div class="kb-select-envoltorio">
                  <select id="currency" class="kb-select" formControlName="currency">
                    <option value="USD">USD</option>
                    <option value="VES">VES</option>
                  </select>
                  <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
                </div>
              </div>
              <div>
                <label class="kb-label" for="total_amount">Monto</label>
                <input id="total_amount" class="kb-input" type="number" min="0" step="0.01"
                       formControlName="total_amount" placeholder="0,00" />
              </div>
              <div>
                <label class="kb-label" for="invoice">Factura</label>
                <input id="invoice" class="kb-input" type="text" formControlName="invoice" placeholder="N° de factura" />
                <p class="kb-hint">Se pide al crear, no al simular.</p>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label class="kb-label" for="plan">Plan</label>
                <div class="kb-select-envoltorio">
                  <select id="plan" class="kb-select" formControlName="plan">
                    <option value="">El que corresponda por cupo</option>
                    <option *ngFor="let p of plans" [value]="p?._id">{{ p?.name }}</option>
                  </select>
                  <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
                </div>
                <p class="kb-hint">Dejalo vacío y el núcleo elige el plan aplicable.</p>
              </div>
              <div>
                <label class="kb-label" for="item">Producto (opcional)</label>
                <input id="item" class="kb-input" type="text" formControlName="item" placeholder="Código del artículo" />
              </div>
            </div>

            <div class="kb-aviso kb-aviso-peligro" *ngIf="errorMsg">
              <div class="kb-aviso-titulo">No se pudo simular</div>
              <div>{{ errorMsg }}</div>
            </div>

            <ng-container *ngTemplateOutlet="trazaTpl; context: {claves: ['cupo']}"></ng-container>

            <div class="kb-aviso kb-aviso-alerta" *ngIf="!puntoDeVentaListo">
              <div class="kb-aviso-titulo">Falta el punto de venta</div>
              <div>Elija la tienda y registre la cédula del ejecutivo antes de simular.</div>
            </div>

            <div class="kb-separador"></div>

            <div class="kb-acciones-grupo">
              <button type="submit" class="kb-btn kb-btn-primary"
                      [disabled]="simulando || !puntoDeVentaListo || form.get('identity')?.invalid || !form.get('total_amount')?.value">
                <i class="fas fa-calculator" *ngIf="!simulando"></i>
                <i class="fas fa-circle-notch fa-spin" *ngIf="simulando"></i>
                {{ simulando ? 'Simulando…' : 'Simular crédito' }}
              </button>
              <button type="button" class="kb-btn kb-btn-outline" (click)="limpiar()" [disabled]="simulando">
                Limpiar
              </button>
            </div>

          </form>
        </div>
      </div>

      <!-- ── Simulación: lo que el cliente va a firmar ───────────────────── -->
      <div class="space-y-6" *ngIf="simulacion">

        <div class="kb-stat-grid">
          <div class="kb-stat">
            <div class="kb-stat-fila">
              <div>
                <div class="kb-stat-label">Monto total</div>
                <div class="kb-stat-valor">{{ simulacion?.total_currency[monedaSimulada]?.total_amount | currency:monedaSimulada:'':'1.2-2' }}</div>
                <div class="kb-stat-pie">{{ monedaSimulada }}</div>
              </div>
              <div class="kb-stat-icono"><i class="fas fa-shopping-cart"></i></div>
            </div>
          </div>
          <div class="kb-stat">
            <div class="kb-stat-fila">
              <div>
                <div class="kb-stat-label">Inicial a cobrar</div>
                <div class="kb-stat-valor">{{ simulacion?.total_currency[monedaSimulada]?.initiala_amount | currency:monedaSimulada:'':'1.2-2' }}</div>
                <div class="kb-stat-pie">se registra al crear el crédito</div>
              </div>
              <div class="kb-stat-icono"><i class="fas fa-hand-holding-usd"></i></div>
            </div>
          </div>
          <div class="kb-stat">
            <div class="kb-stat-fila">
              <div>
                <div class="kb-stat-label">Cupo por usar</div>
                <div class="kb-stat-valor">{{ simulacion?.outstanding_balance | currency:'USD':'':'1.2-2' }}</div>
                <div class="kb-stat-pie">USD</div>
              </div>
              <div class="kb-stat-icono"><i class="fas fa-wallet"></i></div>
            </div>
          </div>
          <div class="kb-stat">
            <div class="kb-stat-fila">
              <div>
                <div class="kb-stat-label">Cuotas</div>
                <div class="kb-stat-valor">{{ cuotas.length }}</div>
                <div class="kb-stat-pie">{{ planSeleccionado?.name || 'plan por cupo' }}</div>
              </div>
              <div class="kb-stat-icono"><i class="fas fa-calendar-alt"></i></div>
            </div>
          </div>
        </div>

        <div class="kb-card">
          <div class="kb-card-header">
            <div>
              <h2 class="kb-card-title">{{ nombreCliente || 'Cliente' }}</h2>
              <p class="kb-card-desc">
                {{ form.getRawValue()?.code_identity }}{{ form.getRawValue()?.identity }} ·
                plan {{ planSeleccionado?.name || '—' }}
              </p>
            </div>
            <div class="kb-acciones-grupo">
              <span class="kb-badge kb-badge-marca" *ngIf="comercioDeLaVenta">{{ comercioDeLaVenta }}</span>
              <span class="kb-badge kb-badge-exito">Cupo alcanza</span>
            </div>
          </div>

          <div class="kb-card-body kb-card-body-plano">
            <div class="kb-table-envoltorio">
              <table class="kb-table">
                <thead class="kb-thead">
                  <tr>
                    <th class="kb-th">Cuota</th>
                    <th class="kb-th">Se paga el</th>
                    <th class="kb-th kb-th-num">Monto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="kb-tr kb-tr-zebra" *ngFor="let item of simulacion?.installments; let i = index">
                    <td class="kb-td kb-td-titulo">{{ item?.order < 1 ? 'Inicial' : 'Cuota ' + item?.order }}</td>
                    <td class="kb-td kb-td-sub">{{ item?.scheduledPaymentDate | date: 'dd/MM/yyyy' }}</td>
                    <td class="kb-td kb-td-num">{{ item?.amount | currency:'USD':'':'1.2-2' }} USD</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="kb-empty" *ngIf="!simulacion?.installments?.length">
              <div class="kb-empty-icono"><i class="fas fa-calendar-times"></i></div>
              <div class="kb-empty-titulo">Sin plan de pago</div>
              <div class="kb-empty-texto">La simulación no devolvió cuotas para este monto.</div>
            </div>
          </div>

          <div class="kb-card-footer">
            <button type="button" class="kb-btn kb-btn-outline" (click)="volverASimular()" [disabled]="creando">
              Volver a simular
            </button>
            <button type="button" class="kb-btn kb-btn-primary" (click)="crearCredito()"
                    [disabled]="creando || !form.get('invoice')?.value">
              <i class="fas fa-credit-card" *ngIf="!creando"></i>
              <i class="fas fa-circle-notch fa-spin" *ngIf="creando"></i>
              {{ creando ? 'Creando…' : 'Crear el crédito' }}
            </button>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="trazaTpl; context: {claves: ['cupo']}"></ng-container>

        <div class="kb-aviso kb-aviso-alerta" *ngIf="!form.get('invoice')?.value">
          <div class="kb-aviso-titulo">Falta el número de factura</div>
          <div>Es lo único que la simulación no pide y la creación sí.</div>
        </div>

        <div class="kb-aviso kb-aviso-info">
          <div class="kb-aviso-titulo">Después de crear</div>
          <div>
            El cliente tiene que aceptar el pagaré desde su app. Mientras no lo acepte, la caja no
            puede cerrar la venta: el núcleo rechaza la inicial con «Pagaré no aceptado».
          </div>
        </div>

      </div>

    </div>

  </div>

  <!-- ══ MODAL DE AYUDA ═══════════════════════════════════════════════════
       Lo que antes ocupaba una columna fija al costado: se lee una vez, no en
       cada venta. Detras del icono del encabezado. -->
  <div class="kb-modal-fondo" *ngIf="ayudaAbierta">
    <div class="kb-modal">
      <div class="kb-modal-header">
        <div>
          <h3 class="kb-modal-titulo">Cómo funciona esta pantalla</h3>
          <p class="kb-modal-desc">Cuatro pasos: tres por la pasarela, el pagaré directo al núcleo.</p>
        </div>
        <button type="button" class="kb-modal-cerrar" (click)="ayudaAbierta = false">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="kb-modal-body">
        <div class="kb-fila-lista">
          <div class="kb-fila">
            <span class="kb-fila-label">1 · Punto de venta</span>
            <span class="kb-fila-valor">tienda y ejecutivo</span>
          </div>
          <div class="kb-fila">
            <span class="kb-fila-label">2 · Simular</span>
            <span class="kb-fila-valor">no escribe nada</span>
          </div>
          <div class="kb-fila">
            <span class="kb-fila-label">3 · Crear</span>
            <span class="kb-fila-valor">crédito + inicial</span>
          </div>
          <div class="kb-fila">
            <span class="kb-fila-label">4 · Pagaré</span>
            <span class="kb-fila-valor">lo acepta el cliente</span>
          </div>
        </div>

        <div class="kb-ficha-titulo mt-4">Qué valida el núcleo</div>
        <div class="kb-fila-lista">
          <div class="kb-fila">
            <span class="kb-fila-label">Cupo disponible</span>
            <span class="kb-fila-valor kb-texto-exito"><i class="fas fa-check"></i></span>
          </div>
          <div class="kb-fila">
            <span class="kb-fila-label">Cliente al día</span>
            <span class="kb-fila-valor kb-texto-exito"><i class="fas fa-check"></i></span>
          </div>
          <div class="kb-fila">
            <span class="kb-fila-label">Plan aplicable al monto</span>
            <span class="kb-fila-valor kb-texto-exito"><i class="fas fa-check"></i></span>
          </div>
          <div class="kb-fila">
            <span class="kb-fila-label">Tienda del comercio</span>
            <span class="kb-fila-valor kb-texto-exito"><i class="fas fa-check"></i></span>
          </div>
        </div>

        <div class="kb-aviso kb-aviso-info">
          <div class="kb-aviso-titulo">Esta pantalla es de prueba</div>
          <div>
            Simula una caja del modelo viejo: cupo, crear e inicial salen por la pasarela con las
            credenciales de la caja; el pagaré lo acepta el cliente (acá se emula, directo al núcleo).
            Lo que se cree acá es un crédito real en el ambiente al que apunte la pasarela.
          </div>
        </div>
      </div>

      <div class="kb-modal-footer">
        <button type="button" class="kb-btn kb-btn-primary" (click)="ayudaAbierta = false">Entendido</button>
      </div>
    </div>
  </div>

  <!-- ══ MODAL: EL CIERRE DE LA VENTA ════════════════════════════════════
       Crear el crédito no cierra nada. Faltan dos pasos que el núcleo exige en
       este orden: el cliente acepta el pagaré y recién ahí la caja puede
       registrar la inicial. Se hacen acá para poder probar el circuito entero. -->
  <div class="kb-modal-fondo" *ngIf="modalAbierto">
    <div class="kb-modal">

      <div class="kb-modal-header">
        <div>
          <h3 class="kb-modal-titulo">
            <span *ngIf="!resultado?.exito">No se pudo crear</span>
            <span *ngIf="resultado?.exito && cierre !== 'listo'">Crédito creado</span>
            <span *ngIf="resultado?.exito && cierre === 'listo'">Venta cerrada</span>
          </h3>
          <p class="kb-modal-desc">
            <span *ngIf="!resultado?.exito">{{ resultado?.mensaje }}</span>
            <span *ngIf="resultado?.exito && cierre !== 'listo'">{{ resultado?.mensaje }}</span>
            <span *ngIf="resultado?.exito && cierre === 'listo'">Pagaré aceptado e inicial registrada.</span>
          </p>
        </div>
        <button type="button" class="kb-modal-cerrar" (click)="cerrarModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="kb-modal-body">

        <div class="kb-kv" *ngIf="resultado?.exito">
          <div>
            <div class="kb-kv-label">Identificador</div>
            <div class="kb-kv-valor" *ngIf="resultado?.identificador">{{ resultado?.identificador }}</div>
            <div class="kb-kv-vacio" *ngIf="!resultado?.identificador">no devuelto</div>
          </div>
          <div>
            <div class="kb-kv-label">Cliente</div>
            <div class="kb-kv-valor">{{ nombreCliente || '—' }}</div>
          </div>
        </div>

        <!-- Los dos pasos que faltan -->
        <div class="kb-steps mt-5" *ngIf="resultado?.exito">
          <div class="kb-step">
            <span class="kb-step-bolita"
                  [ngClass]="{'kb-step-bolita-activa': cierre === 'pagare', 'kb-step-bolita-hecha': cierre === 'inicial' || cierre === 'listo'}">1</span>
            <span class="kb-step-label" [ngClass]="{'kb-step-label-activa': cierre === 'pagare'}">Pagaré</span>
            <span class="kb-step-linea"></span>
          </div>
          <div class="kb-step">
            <span class="kb-step-bolita"
                  [ngClass]="{'kb-step-bolita-activa': cierre === 'inicial', 'kb-step-bolita-hecha': cierre === 'listo'}">2</span>
            <span class="kb-step-label" [ngClass]="{'kb-step-label-activa': cierre === 'inicial'}">Inicial</span>
          </div>
        </div>

        <div class="mt-3">
          <ng-container *ngTemplateOutlet="trazaTpl; context: {claves: ['crear', 'inicial']}"></ng-container>
        </div>

        <div class="kb-aviso kb-aviso-peligro mt-4" *ngIf="errorCierre">
          <div class="kb-aviso-titulo">Se cortó acá</div>
          <div>{{ errorCierre }}</div>
        </div>

        <!-- Paso 1: el pagaré -->
        <div class="mt-4" *ngIf="resultado?.exito && cierre === 'pagare'">
          <p class="kb-hint mb-2">
            Esto lo hace el cliente en su app; acá se emula. Va directo al núcleo, no por la pasarela.
          </p>
          <div *ngIf="buscandoPagare" class="space-y-2">
            <div class="kb-skeleton h-4 w-48"></div>
            <div class="kb-skeleton h-4 w-32"></div>
          </div>

          <div class="kb-aviso kb-aviso-alerta" *ngIf="!buscandoPagare && pagarePendiente">
            <div class="kb-aviso-titulo">El cliente tiene que aceptar el pagaré</div>
            <div>
              Sin eso, el núcleo rechaza la inicial con «Pagaré no aceptado». En la calle lo acepta
              el cliente desde su app; acá lo puede aceptar por él para terminar la prueba.
            </div>
          </div>

          <div class="kb-aviso kb-aviso-alerta" *ngIf="!buscandoPagare && !pagarePendiente && !errorCierre">
            <div class="kb-aviso-titulo">No encontré el pagaré</div>
            <div>Puede que todavía se esté generando. Probá de nuevo en unos segundos.</div>
          </div>
        </div>

        <!-- Paso 2: la inicial -->
        <div class="mt-4" *ngIf="resultado?.exito && cierre === 'inicial'">
          <div class="kb-fila-lista">
            <div class="kb-fila">
              <span class="kb-fila-label">Inicial a cobrar</span>
              <span class="kb-fila-valor">{{ montoInicial | currency:monedaSimulada:'':'1.2-2' }} {{ monedaSimulada }}</span>
            </div>
            <div class="kb-fila">
              <span class="kb-fila-label">Forma de pago</span>
              <span class="kb-fila-valor">Efectivo</span>
            </div>
          </div>
          <div class="kb-aviso kb-aviso-info mt-3">
            <div class="kb-aviso-titulo">La cobra la caja</div>
            <div>El núcleo la registra siempre como efectivo, mande lo que mande la pantalla.</div>
          </div>
        </div>

        <!-- Listo -->
        <div class="kb-aviso kb-aviso-info mt-4" *ngIf="cierre === 'listo'">
          <div class="kb-aviso-titulo">Circuito completo</div>
          <div>Crédito creado, pagaré aceptado e inicial registrada. La venta quedó cerrada.</div>
        </div>

      </div>

      <div class="kb-modal-footer">
        <button type="button" class="kb-btn kb-btn-outline" (click)="buscarPagare()"
                *ngIf="cierre === 'pagare' && !pagarePendiente && !buscandoPagare">
          Buscar de nuevo
        </button>

        <!-- El cliente puede aceptar el pagaré desde su teléfono: si ya lo hizo,
             la inicial se manda directo sin aceptarlo acá. Si todavía no lo
             aceptó, el núcleo contesta «Pagaré no aceptado» y se muestra. -->
        <button type="button" class="kb-btn kb-btn-outline" (click)="registrarInicial()"
                *ngIf="cierre === 'pagare'" [disabled]="registrandoInicial">
          <i class="fas fa-hand-holding-usd" *ngIf="!registrandoInicial"></i>
          <i class="fas fa-circle-notch fa-spin" *ngIf="registrandoInicial"></i>
          {{ registrandoInicial ? 'Enviando…' : 'Enviar inicial' }}
        </button>

        <button type="button" class="kb-btn kb-btn-primary" (click)="aceptarPagare()"
                *ngIf="cierre === 'pagare' && pagarePendiente"
                [disabled]="aceptandoPagare">
          <i class="fas fa-file-signature" *ngIf="!aceptandoPagare"></i>
          <i class="fas fa-circle-notch fa-spin" *ngIf="aceptandoPagare"></i>
          {{ aceptandoPagare ? 'Aceptando…' : 'Aceptar el pagaré' }}
        </button>

        <button type="button" class="kb-btn kb-btn-primary" (click)="registrarInicial()"
                *ngIf="cierre === 'inicial'" [disabled]="registrandoInicial">
          <i class="fas fa-hand-holding-usd" *ngIf="!registrandoInicial"></i>
          <i class="fas fa-circle-notch fa-spin" *ngIf="registrandoInicial"></i>
          {{ registrandoInicial ? 'Enviando…' : 'Enviar inicial' }}
        </button>

        <button type="button" class="kb-btn kb-btn-primary" (click)="cerrarModal()"
                *ngIf="!resultado?.exito || cierre === 'listo'">
          {{ resultado?.exito ? 'Cargar otra venta' : 'Cerrar' }}
        </button>
      </div>

    </div>
  </div>


  <!-- ══ MODAL: INICIAL DE UN CRÉDITO YA CREADO ═══════════════════════════ -->
  <div class="kb-modal-fondo" *ngIf="modalSuelta">
    <div class="kb-modal">
      <div class="kb-modal-header">
        <div>
          <h3 class="kb-modal-titulo">Cargar la inicial de un crédito</h3>
          <p class="kb-modal-desc">
            Para un crédito que ya existe. Sirve cuando el cliente aceptó el pagaré después y la
            venta quedó a medias.
          </p>
        </div>
        <button type="button" class="kb-modal-cerrar" (click)="cerrarInicialSuelta()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="kb-modal-body">
        <form [formGroup]="sueltaForm" class="space-y-4">
          <div>
            <label class="kb-label" for="s-identifier">Identificador del crédito</label>
            <input id="s-identifier" class="kb-input" type="text" formControlName="identifier"
                   placeholder="CREDIT-0000000" />
            <p class="kb-hint">Es el código que devuelve la creación, con el prefijo incluido.</p>
          </div>

          <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
            <div>
              <label class="kb-label" for="s-code">Documento</label>
              <div class="kb-select-envoltorio">
                <select id="s-code" class="kb-select" formControlName="code_identity">
                  <option *ngFor="let c of code_identity" [value]="c?.code || c">{{ c?.name || c?.code || c }}</option>
                </select>
                <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
              </div>
            </div>
            <div class="sm:col-span-2">
              <label class="kb-label" for="s-identity">Cédula del cliente</label>
              <input id="s-identity" class="kb-input" type="text" formControlName="identity"
                     placeholder="12345678" maxlength="8" />
            </div>
          </div>

          <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label class="kb-label" for="s-currency">Moneda</label>
              <div class="kb-select-envoltorio">
                <select id="s-currency" class="kb-select" formControlName="currency">
                  <option value="USD">USD</option>
                  <option value="VES">VES</option>
                </select>
                <span class="kb-select-flecha"><i class="fas fa-chevron-down"></i></span>
              </div>
            </div>
            <div>
              <label class="kb-label" for="s-amount">Monto de la inicial</label>
              <input id="s-amount" class="kb-input" type="number" min="0" step="0.01"
                     formControlName="amount" placeholder="0,00" />
            </div>
          </div>
        </form>

        <div class="mt-3">
          <ng-container *ngTemplateOutlet="trazaTpl; context: {claves: ['suelta']}"></ng-container>
        </div>

        <div class="kb-aviso kb-aviso-peligro mt-4" *ngIf="errorSuelta">
          <div class="kb-aviso-titulo">No se pudo</div>
          <div>{{ errorSuelta }}</div>
        </div>

        <div class="kb-aviso kb-aviso-info mt-4" *ngIf="okSuelta">
          <div class="kb-aviso-titulo">Listo</div>
          <div>{{ okSuelta }}</div>
        </div>

        <div class="kb-aviso kb-aviso-alerta mt-4" *ngIf="!okSuelta">
          <div class="kb-aviso-titulo">El pagaré sigue mandando</div>
          <div>
            Si el cliente todavía no aceptó el pagaré desde su teléfono, el núcleo va a rechazar la
            inicial. No es un error de esta pantalla.
          </div>
        </div>
      </div>

      <div class="kb-modal-footer">
        <button type="button" class="kb-btn kb-btn-outline" (click)="cerrarInicialSuelta()">Cerrar</button>
        <button type="button" class="kb-btn kb-btn-primary" (click)="enviarInicialSuelta()"
                [disabled]="enviandoSuelta || sueltaForm?.invalid">
          <i class="fas fa-hand-holding-usd" *ngIf="!enviandoSuelta"></i>
          <i class="fas fa-circle-notch fa-spin" *ngIf="enviandoSuelta"></i>
          {{ enviandoSuelta ? 'Enviando…' : 'Enviar inicial' }}
        </button>
      </div>
    </div>
  </div>

  </ng-container>

</div>
